export default __webpack_public_path__ + "static/media/Send_button.9ba653a0.svg";